import { headerStyles as styles } from "@insite/content-library/Pages/Header";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { secondaryNavigationStyles } from "@solveindustrial/WidgetExtensions/Header/SecondaryNavigationExtension";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        ${styles.page?.css}
        position: relative;

        &&& {
            padding-top: 0;
            padding-bottom: 0;
            z-index: 2;
        }

        ${mediaQueriesBP.minLG} {
            .wrapper {
                ${secondaryNavigationStyles.wrapper}
            }
        }

        .sign-in-link {
            ${secondaryNavigationStyles.signInLink}
        }
    `,
};

const calcInitial = "calc(((100vw - 100%) / 2) * -1)";
const calcEnd = "calc(100% - 20px)";

styles.container = {
    ...styles.container,
    css: css`
        ${styles.container?.css}
        background-color: ${getColor(colorStrings.primaryMain)};

        ${mediaQueriesBP.minMD} {
            &::before,
            &::after {
                content: "";
                background-color: ${getColor(colorStrings.primaryMain)};
                position: absolute;
                height: 50px;
                z-index: 0;
            }

            &::before {
                left: ${calcInitial};
                right: ${calcEnd};
            }

            &::after {
                left: ${calcEnd};
                right: ${calcInitial};
            }

            > div:last-child {
                justify-content: flex-end;
                z-index: 1;
            }
        }
    `,
};
